var _defs, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew263({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.25,
    cy: 8,
    r: 3.08
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.16,
    y1: 8,
    x2: 15.61,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12.07,
    y1: 5.73,
    x2: 13.59,
    y2: 3.81
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.6,
    y1: 5.16,
    x2: 9.06,
    y2: 2.78
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.63,
    y1: 6.74,
    x2: 5.42,
    y2: 5.67
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.63,
    y1: 9.26,
    x2: 5.42,
    y2: 10.32
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.6,
    y1: 10.84,
    x2: 9.05,
    y2: 13.22
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12.06,
    y1: 10.28,
    x2: 13.59,
    y2: 12.19
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7,
    y1: 8,
    x2: 2.35,
    y2: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.47,
    cy: 8,
    r: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew263);
export default __webpack_public_path__ + "static/media/Symbolpack_New_263.e02fb641f5cbaa65683a1eb55a66f3b5.svg";
export { ForwardRef as ReactComponent };